module.exports = __webpack_public_path__ + "img/yt-icon.d24c0c9b.svg";